import { render, staticRenderFns } from "./NotesButton.vue?vue&type=template&id=7dfc3168&scoped=true&"
import script from "./NotesButton.vue?vue&type=script&lang=js&"
export * from "./NotesButton.vue?vue&type=script&lang=js&"
import style0 from "./NotesButton.vue?vue&type=style&index=0&id=7dfc3168&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfc3168",
  null
  
)

export default component.exports